import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.442 4.558a.625.625 0 0 0-.884 0L6.642 7.475a.625.625 0 0 0 .883.884L10 5.884l2.475 2.475a.625.625 0 0 0 .884-.884zm2.917 7.55-2.917 2.917a.625.625 0 0 1-.884 0L6.642 12.11a.625.625 0 0 1 .883-.884L10 13.699l2.475-2.474a.625.625 0 1 1 .884.884",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".2",
  "fill-rule": "evenodd",
  d: "M10.442 4.558a.625.625 0 0 0-.884 0L6.642 7.475a.625.625 0 0 0 .883.884L10 5.884l2.475 2.475a.625.625 0 0 0 .884-.884zm2.917 7.55-2.917 2.917a.625.625 0 0 1-.884 0L6.642 12.11a.625.625 0 0 1 .883-.884L10 13.699l2.475-2.474a.625.625 0 1 1 .884.884",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".2",
  "fill-rule": "evenodd",
  d: "M10.442 4.558a.625.625 0 0 0-.884 0L6.642 7.475a.625.625 0 0 0 .883.884L10 5.884l2.475 2.475a.625.625 0 0 0 .884-.884zm2.917 7.55-2.917 2.917a.625.625 0 0 1-.884 0L6.642 12.11a.625.625 0 0 1 .883-.884L10 13.699l2.475-2.474a.625.625 0 1 1 .884.884",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".2",
  "fill-rule": "evenodd",
  d: "M10.442 4.558a.625.625 0 0 0-.884 0L6.642 7.475a.625.625 0 0 0 .883.884L10 5.884l2.475 2.475a.625.625 0 0 0 .884-.884zm2.917 7.55-2.917 2.917a.625.625 0 0 1-.884 0L6.642 12.11a.625.625 0 0 1 .883-.884L10 13.699l2.475-2.474a.625.625 0 1 1 .884.884",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }